// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uxLc","input":"styles_input__3PtSS"};